import { useMemo, useState } from "react";
import { Modal } from "react-bootstrap";

const SearchableMultiSelectModal = ({
  title = "Select Items",
  options = [],
  selectedValues = [],
  onChange,
  buttonLabel = "Select items",
  emptyLabel = "No items selected",
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const values = useMemo(
    () => (Array.isArray(selectedValues) ? selectedValues : []),
    [selectedValues]
  );
  const selectedSet = useMemo(() => new Set(values), [values]);

  const filteredOptions = useMemo(() => {
    const search = query.trim().toLowerCase();
    if (!search) return options;
    return options.filter((option) =>
      String(option.label || option.name || option.value || "")
        .toLowerCase()
        .includes(search)
    );
  }, [options, query]);

  const selectedLabels = options
    .filter((option) => selectedSet.has(option.value))
    .map((option) => option.label)
    .join(", ");

  const toggleValue = (value) => {
    const next = selectedSet.has(value)
      ? values.filter((item) => item !== value)
      : [...values, value];
    onChange(next);
  };

  return (
    <>
      <button
        type="button"
        className="form-select text-start"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        {values.length
          ? `${values.length} selected`
          : buttonLabel}
      </button>
      <div className="mt-2">
        {selectedLabels ? (
          <div className="small text-dark">{selectedLabels}</div>
        ) : (
          <div className="text-muted small">{emptyLabel}</div>
        )}
      </div>

      <Modal show={open} onHide={() => setOpen(false)} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div className="mb-3">
            <input
              className="form-control"
              placeholder={`Search ${title.toLowerCase()}...`}
              value={query}
              onChange={(event) => setQuery(event.target.value)}
            />
          </div>
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-2">
            {filteredOptions.map((option) => (
              <div className="col" key={option.value}>
                <label className="border rounded p-2 d-flex gap-2 h-100">
                  <input
                    type="checkbox"
                    className="form-check-input mt-1"
                    checked={selectedSet.has(option.value)}
                    onChange={() => toggleValue(option.value)}
                  />
                  <span className="small">{option.label}</span>
                </label>
              </div>
            ))}
          </div>
          {!filteredOptions.length && (
            <div className="text-center text-muted py-4">No items found</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-custom"
            onClick={() => setOpen(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SearchableMultiSelectModal;
